export const IntegrationTypes = {
    MultiTenantApp: 'MultiTenantApp',
    CustomAppRegistration: 'CustomAppRegistration',
} as const;

export type IntegrationType = typeof IntegrationTypes[keyof typeof IntegrationTypes];
